import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CreateSaReportRequest,
  PagedSaReportGetAllResponse,
} from './models/sa_report.service.model';
import { serializeQueryParams } from 'src/app/service-helper';
import { PagedRequest } from 'src/app/paged-request.model';

@Injectable({
  providedIn: 'root',
})
export class SaReportService {
  private baseURL: string = `${environment.apiUrl}/api/SentimentReport`;

  constructor(private http: HttpClient) {}

  get(filter: PagedRequest): Observable<PagedSaReportGetAllResponse> {
    const params = serializeQueryParams(filter);
    return this.http.get<PagedSaReportGetAllResponse>(this.baseURL, { params });
  }

  create(params: CreateSaReportRequest) {
    return this.http.post(this.baseURL, params, { responseType: 'blob', observe: 'response' });
  }

  downloadReport(id: string) {
    return this.http.get(this.baseURL + '/' + id + '/download', {
      responseType: 'blob',
    });
  }
}
